import React, { memo } from 'react'
import PropTypes from 'prop-types'
import PageTemplateData from '@v4/utils/data/PageTemplateData'
import { useContainer } from './Container.hooks'

const Container = props => {
	const [{ Element, collection, className, relatedSections, children }] = useContainer(props)

	return (
		<Element className={className} relatedSections={relatedSections} collection={collection}>
			{children}
		</Element>
	)
}

Container.propTypes = {
	className: PropTypes.string,
	collection: PropTypes.oneOf(Object.values(PageTemplateData.SORT_GROUPS)),
	relatedSections: PropTypes.arrayOf(
		PropTypes.oneOf([PageTemplateData.SORT_GROUPS.HEADER, PageTemplateData.SORT_GROUPS.FOOTER]),
	),
	children: PropTypes.node,
}

export default memo(Container)
